<template>
  <div class="flex flex-col justify-end items-end z-50 fixed right-0 bottom-0">
    <div>
      <a :href="`${wordCardURL}`" target="_blank" class="cursor-pointer block" v-if="wordCardURL && isShow">
        <img src="~@/assets/Word_Cards.png" alt="" class="object-contain">
      </a>
      <a :href="`${aiURL}`" target="_blank" class="cursor-pointer block" v-if="aiURL && isShow">
        <img src="~@/assets/aiBtn.png" alt="" class="object-contain">
      </a>
    </div>
    <a class="cursor-pointer block" @click="isShow = !isShow">
      <img src="~@/assets/closeAI.png" alt="" class="object-contain" v-if="isShow">
      <img src="~@/assets/openAI.png" alt="" class="object-contain" v-if="!isShow">
    </a>
  </div>
</template>

<script setup>
  import { ref } from 'vue'
  defineProps({
    aiURL: {
      type: String,
      default: () => ''
    },
    wordCardURL: {
      type: String,
      default: () => ''
    }
  })
  const isShow = ref(true)
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  top: 2rem;
  right: 2rem;
  z-index: 999;
}

.fab {
  background-color: #009fe3;
  color: white;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  font-size: 24px;
  border: none;
  cursor: pointer;
}

.fab-action {
  display: block;
  margin-top: 10px;
  background-color: #75982b;
  color: white;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  font-size: 20px;
  cursor: pointer;
}
</style>
